<div
  class="product-list-card"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_rounded]="loading"
  [routerLink]="['/loyalty', 'product', product?.id]"
  [queryParams]="{ unionId: externalUnionId, collectionId, ref }"
>
  <app-photo
    class="product-list-card__image"
    [text]="product?.contacts?.company?.name"
    [type]="'photo'"
    [id]="product?.contacts?.company?.logoId"
    [unionId]="externalUnionId"
    [width]="isDesktop ? '93px' : '70px'"
    [height]="isDesktop ? '93px' : '70px'"
    [rounded]="true"
    [showPreview]="false"
  ></app-photo>

  <div class="product-list-card__info">
    <div class="title max-row-2">{{ product?.name }}</div>

    <div class="description max-row-2">
      {{ product?.descriptionShort }}
    </div>
  </div>

  <div class="product-list-card__discount max-row-2 text_bold">
    {{ product?.discountText }}
  </div>
</div>
